import { i18n } from '../langs';
import axios from 'axios'
import { LOGIN_URL, API_BASE_URL, APPLICANT_API_BASE_URL, RECRUITER_API_BASE_URL, EXTERNAL_API_BASE_URL, REFERRER_PORTAL_API_BASE_URL, CSRF_TOKEN, USER_API_BASE_URL } from '../config'

axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': CSRF_TOKEN
};

axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    return {
        status: response.status,
        statusText: response.statusText,
        data: response.data
    };
}, function (error) {
    // Do something with response error
    // Redirect to login in case of unauthenticated error
    if (error.response) {
        const { status, statusText, data } = error.response;

        if (status === 401) {
            // Redirigir a login y detener el flujo
            window.location.href = LOGIN_URL;
            return new Promise(() => {}); // Nunca se resuelve ni rechaza
        }

        if (status === 403) {
            // Mostrar toast si Materialize está disponible
            if (typeof M !== "undefined") {
                M.toast({
                    html: i18n.t('recruiters.alert.messages.errors.response_forbidden'),
                    displayLength: 3000,
                    classes: "red rounded",
                });
            } else {
                console.warn('Materialize CSS no está cargado');
            }
        }

        const customError = new Error(statusText || 'Error en la respuesta');
        customError.status = status;
        customError.data = data;

        return Promise.reject(customError);
    } else {
        return Promise.reject(error);
    }
});

export {
    axios,
    API_BASE_URL,
    APPLICANT_API_BASE_URL,
    RECRUITER_API_BASE_URL,
    EXTERNAL_API_BASE_URL,
    REFERRER_PORTAL_API_BASE_URL,
    USER_API_BASE_URL
}